import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Oh.Thell.O" link="https://www.youtube.com/watch?v=nOfFKS_U_Mw" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  This student project was built during my studies in only one weekend! Built with React-Native and Expo as a learning experience.
    </ProjectCard>
    <ProjectCard title="City Snapper" link="https://www.youtube.com/watch?v=ZKVtpGCUbBc&index=3&list=PLx0iOsdUOUmmMdgcWgABSEBRkSWAG3aNP" bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)" mdxType="ProjectCard">
  Mobile app built as a capstone project. Built for iOS and Android using React-Native, Expo, Firebase, React-Redux/Redux, Google Maps and MapBox, and machine vision recognition.
    </ProjectCard>
    <ProjectCard title="project MERCURY" link="https://www.projectmercury.ventures" bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
  This site was made for Mythology in NYC, built with React, Bulma, React-Spring, and SASS, webhooks to Airtable & auto-generated email responses.
    </ProjectCard>
    <ProjectCard title="Half Moon BK" link="/" bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)" mdxType="ProjectCard">
  COMING SOON! Re-launch of web radio station Half Moon BK! Currently being built with Gatsby, Netlify CMS, React-Spring, Bulma, and more!
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      